import React from "react";
import styles from "./KeyValueItem.module.sass";

const keyValueItem = (props) => {
  return (
    <React.Fragment>
      <div
        className={[
          props.column ? "flex-column" : "flex-row",
          props.className,
        ].join(" ")}
      >
        <label className={styles.Key}>{props.Key}</label>
        <label className={styles.Value}>{props.Value}</label>
      </div>
      {!props.noDivider ? <div className={styles.divider} /> : null}
    </React.Fragment>
  );
};

export default keyValueItem;
